// src/components/BundleDetail.jsx

import React, { useEffect, useState } from 'react';
import {api} from  "../Login/axiosConfig";
import { useAuth } from '../../AuthContext';
import { useParams } from 'react-router-dom';
import { Link, useLocation } from 'react-router-dom';
import {
  Box,
  Typography,
  Card,
  CardMedia,
  CardContent,
  CardActions,
  Button,
  CircularProgress,
  Grid,
  Chip,
  IconButton,
  Avatar,
  Tooltip,
  Link as MuiLink
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Header1 from '../Header/Header1';
import Footer2 from '../Footer/Footer2';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { formatDateWithSuffix } from '../utils/formatDate';
import { formatTimeToAMPM } from '../utils/formatTime';
import { formatDuration } from '../utils/formatDuration';
import Platform from '../Platform/Platform';
import ShareButton from '../Share/ShareButton';
import { CheckCircleOutline } from '@mui/icons-material';
import { ErrorOutline } from '@mui/icons-material';
import ReserveButton from '../UserReservations/ReserveButton';
import JoinButton from '../Post/JoinButton';

const API_URL = process.env.REACT_APP_API_URL;

function BundleDetail({ onLogout }) {
  const { userId } = useAuth();
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const postId = id

  const [post, setPost] = useState(null);
  const [userData,setUserData] = useState(null);
  const [sessions, setSessions] = useState([]);
  const [highlight, setHighlight] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const paymentStatus = location.state?.paymentStatus || 'unknown';  // Default to 'unknown' if not provided
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [bookingCreated, setBookingCreated] = useState(false);
  const [loadingSeconds, setLoadingSeconds] = useState(0);
  
  
  
      useEffect(() => {
          let timer;
        
          if (loading) {
            setLoadingSeconds(0); // reset timer
            timer = setInterval(() => {
              setLoadingSeconds(prev => prev + 1);
            }, 1000);
          } else {
            clearInterval(timer);
            setLoadingSeconds(0); // optional reset after done
          }
        
          return () => clearInterval(timer); // cleanup on unmount or loading = false
        }, [loading]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await fetch(`${API_URL}/api/bundles/?post_id=${postId}`);
        if (!res.ok) throw new Error('Failed to fetch');
        const data = await res.json();
        setPost(data.post);
        setUserData(data.user);
        setSessions(data.sessions);
        setHighlight(data.post); // Set default highlighted item to bundle
      } catch (err) {
        console.error(err);
        setError('Failed to load bundle');
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [postId]);

//   useEffect(() => {
//   setLoading(true);

//   const dummyData = {
//     post: {
//       id: postId,
//       title: "Full Stack Live Bootcamp",
//       description: "Learn frontend + backend in live sessions.",
//       media_type: "video",
//       media_url: "https://www.w3schools.com/html/mov_bbb.mp4",
//       language: "English",
//       price: 0,
//     },

//     user: {
//       name: "John",
//       surname: "Doe",
//       image: "",
//       expert_id: 1,
//     },

//     sessions: [
//       {
//         id: 1,
//         session_title: "React Basics Live",
//         description: "Understand components, props, hooks.",
//         media_type: "video",
//         media_url: "https://www.w3schools.com/html/movie.mp4",
//         selectedDate: "2026-03-20",
//         startTime: "18:00",
//         duration: 60,
//         language: "English",
//         price: 0,

//         // 🔥 for next (agora)
//         channel_name: "session_1",
//         session_type: "live",
//       },
//       {
//         id: 2,
//         session_title: "Node.js Backend",
//         description: "Build APIs with Express.",
//         media_type: "image",
//         media_url: "https://images.unsplash.com/photo-1555066931-4365d14bab8c",
//         selectedDate: "2026-03-21",
//         startTime: "19:00",
//         duration: 90,
//         language: "English",
//         price: 0,
//         channel_name: "session_2",
//         session_type: "live",
//       },
//       {
//         id: 3,
//         session_title: "Database Design",
//         description: "Learn SQL & schema design.",
//         media_type: "image",
//         media_url: "https://images.unsplash.com/photo-1544383835-bda2bc66a55d",
//         selectedDate: "2026-03-22",
//         startTime: "17:30",
//         duration: 75,
//         language: "English",
//         price: 0,
//         channel_name: "session_3",
//         session_type: "live",
//       },
//       {
//         id: 4,
//         session_title: "System Design Live",
//         description: "Scalable system architecture.",
//         media_type: "video",
//         media_url: "https://www.w3schools.com/html/mov_bbb.mp4",
//         selectedDate: "2026-03-23",
//         startTime: "20:00",
//         duration: 60,
//         language: "English",
//         price: 0,
//         channel_name: "session_4",
//         session_type: "live",
//       },
//     ],
//   };

//   setTimeout(() => {
//     setPost(dummyData.post);
//     setUserData(dummyData.user);
//     setSessions(dummyData.sessions);
//     setHighlight(dummyData.post);
//     setLoading(false);
//   }, 500);

// }, [postId]);
  const handleSessionClick = (session) => {
    setHighlight(session);
  };

  const handleBackToBundle = () => {
    setHighlight(post);
  };

  const createUserPostBookings = async () => {
    try {
      const response = await fetch(`${API_URL}/create_user_post_booking/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          post_id: id,
          user_id: userId,
        }),
      });

      const data = await response.json();
      if (response.ok) {
        setBookingCreated(true);
      }
    } catch (error) {
      console.error('Error creating booking:', error);
    }
  };

  if (loading) {
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 2000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backdropFilter: 'blur(3px)',
      }}
    >
      <Box sx={{ textAlign: 'center' }}>
        <CircularProgress
          size={60}
          thickness={6}
          sx={{
            color: 'transparent',
            '& .MuiCircularProgress-circle': {
              stroke: 'url(#better-gradient)',
            },
          }}
        />

        {/* SVG Gradient Definition */}
        <svg width="0" height="0">
          <defs>
            <linearGradient id="better-gradient" x1="1" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#f30b96ff" />
              <stop offset="50%" stopColor="#221ce0ff" />
              <stop offset="100%" stopColor="#0eacebff" />
            </linearGradient>
          </defs>
        </svg>

        <Typography
          variant="h6"
          sx={{
            mt: 2,
            color: '#fff',
            textShadow: '0 1px 3px rgba(0,0,0,0.7)',
          }}
        >
          Loading Session Details... ({loadingSeconds} sec)
        </Typography>
      </Box>
    </Box>
  );
}

const getPresignedUrl = async (key) => {
  try {
    const res = await api.get(`${API_URL}/posts/media-url/`, {
      params: { key },
    });
    return res.data.url;
  } catch (error) {
    console.error("Failed to fetch presigned URL:", error);
    return null;
  }
};


  if (error || !post) {
    return (
      <Box sx={{ textAlign: 'center', mt: 6 }}>
        <Typography color="error">{error || 'No data available'}</Typography>
      </Box>
    );
  }

  return (
    <div>

      <Box
                                  sx={{
                                    position: 'fixed', // or 'relative' / 'sticky' based on your layout
                                    top: 0,
                                    left: 0,
                                    width: '100%',
                                    zIndex: 1300, // higher than MUI drawers (default is 1200)
                                  }}
                                >
                                  <Header1 onLogout={onLogout} />
                                </Box>
                          
      <Box sx={{ maxWidth: '1200px', mx: 'auto', p: 3, mt: 7 }}>


        <Card
          sx={{
            position: 'relative',
            display: 'flex',
            flexDirection: ['column', 'row'],
            mb: 5,
            borderRadius: 3,
            background: 'rgba(255, 255, 255, 0.05)',
            backdropFilter: 'blur(10px)',
            boxShadow: 5,
            overflow: 'hidden',
          }}
        >
          <Box sx={{ position: 'absolute', top: 6, right: 6 }}>
              <ShareButton postUrl={`${window.location.origin}/share/bundle/${id}`} />
            </Box>
          {highlight.media_url && (
            <CardMedia
              component={highlight.media_type === 'video' ? 'video' : 'img'}
              src={highlight.media_url}
              controls
              sx={{ width: ['100%', '60%'], height: 700, objectFit: 'cover' }}
            />
          )}
          <CardContent sx={{ flex: 1, p: 4 }}>
            {highlight.id !== post.id && (
              <IconButton onClick={handleBackToBundle} sx={{ mb: 1 }}>
                <ArrowBackIcon />
              </IconButton>
            )}
            <Typography variant="h4" gutterBottom fontWeight={600}>
              {highlight.session_title || highlight.title || 'Highlighted Session'}
            </Typography>

            <Grid container spacing={2} justifyContent="left" sx={{ mt: 1, mb: 5 }}>
              
                                          <Box
                                              sx={{
                                                  position: 'relative',
                                                  display: 'flex',
                                                  flexDirection: 'row',
                                                  alignItems: 'center',
                                                  gap: 2, // replaces manual margin for spacing
                                                  pt: '1rem',
                                              }}
                                          >
                                              
              
                                              <Avatar
                                                                                          sx={{ width: 50, height: 50, bgcolor: '#0a2e57ff', fontSize: 28 }}
                                                                                          src={userData.image || undefined}
                                                                                        >
                                                                                          {!userData.image && userData.name
                                                                                            ? userData.name.charAt(0).toUpperCase()
                                                                                            : null}
                                                                                        </Avatar>
                                              
              
                                              <Tooltip title="Click to view" placement="bottom">
                                                  <Typography
                  variant="h6"
                  onClick={() => navigate(`/expert-profile?expert_id=${userData.expert_id}`)}
                  sx={{
                      fontWeight: 'bold',
                      color: '#fff',
                      fontFamily: "'Helvetica', sans-serif",
                      letterSpacing: '0.15em',
                      fontSize: { xs: '1.2rem', sm: '1.5rem', md: '1.8rem' },
                      cursor: 'pointer',
                      transition: 'color 0.3s ease-in-out',
                      '&:hover': {
                          color: '#1E90FF',
                      },
                  }}
              >
                  {userData.name || 'Name'} {userData.surname || 'Surname'}
              </Typography>
              
                                              </Tooltip>
                                          </Box>

              {/* Date & Time */}
              {highlight.selectedDate && highlight.startTime && (
                <Grid item>
                  <Typography
                    sx={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: 1,
                      fontWeight: '600',
                      fontSize: '1rem',
                      color: '#ffffff',
                      background: 'linear-gradient(135deg, #2079c2ff 0%, #1f2c33ff 100%)',
                      px: 2,
                      py: 0.5,
                      borderRadius: '18px',
                      boxShadow: '0 2px 10px rgba(48, 71, 83, 0.4)',
                      whiteSpace: 'nowrap',
                      textShadow: '0 1px 2px rgba(0,0,0,0.4)',
                      letterSpacing: 0.4,
                      userSelect: 'none',
                      width: 'fit-content',
                      cursor: 'default',
                    }}
                  >
                    🗓 <span>{formatTimeToAMPM(highlight.startTime)} • {formatDateWithSuffix(highlight.selectedDate)}</span>
                  </Typography>
                </Grid>
              )}


              {/* Language */}
              {highlight.language && (
                <Grid item>
                  <Typography
                    sx={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: 1,
                      fontWeight: '600',
                      fontSize: '1rem',
                      color: '#ffffff',
                      background: 'linear-gradient(135deg, #c78b1cff, #27231aff)',
                      px: 2,
                      py: 0.5,
                      borderRadius: '20px',
                      boxShadow: '0 0 10px rgba(160, 124, 45, 0.3)',
                      letterSpacing: 0.3,
                      whiteSpace: 'nowrap',
                      textShadow: '0 0 4px rgba(0,0,0,0.25)',
                      userSelect: 'none',
                      cursor: 'default',
                      width: 'fit-content',
                    }}
                  >
                    🗣 {highlight.language}
                  </Typography>
                </Grid>
              )}

              {/* Price */}
              {/* {highlight.price && (
                <Grid item>
                  <Typography
                    sx={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: 1,
                      fontWeight: '600',
                      fontSize: '1rem',
                      color: '#ffffff',
                      background: 'linear-gradient(135deg, #bcc71cff, #27231aff)',
                      px: 2,
                      py: 0.5,
                      borderRadius: '20px',
                      boxShadow: '0 0 10px rgba(160, 124, 45, 0.3)',
                      letterSpacing: 0.3,
                      whiteSpace: 'nowrap',
                      textShadow: '0 0 4px rgba(0,0,0,0.25)',
                      userSelect: 'none',
                      cursor: 'default',
                      width: 'fit-content',
                    }}
                  >
                    ₹{highlight.price}
                  </Typography>
                </Grid>
              )} */}

            </Grid>


            {/* Description */}
            <Grid item xs={12}>
              <Typography
                sx={{
                  background: 'rgba(255, 255, 255, 0.05)',
                  borderLeft: '4px solid #1976d2',
                  padding: 2,
                  borderRadius: '8px',
                  fontSize: '0.95rem',
                  lineHeight: 1.6,
                  color: '#e0e0e0',
                  boxShadow: 'inset 0 0 5px rgba(255,255,255,0.05)',
                  whiteSpace: 'pre-wrap',
                  wordBreak: 'break-word',
                }}
              >
                {highlight.description || 'No description provided.'}
              </Typography>
            </Grid>
            <JoinButton
  postId={highlight.id}
  hostUserId={userData?.expert_id}
  title={highlight.session_title || highlight.title}
/>

              {/* <Button
                                        variant="contained"
                                        color="primary"
                                        endIcon={<PlayCircleOutlineIcon />}
                                        sx={{ mt: 2 }}
                                        disabled={!highlight.meeting_link}
                                        onClick={() => {
                                            if (highlight.meeting_link) {
                                                window.open(highlight.meeting_link, '_blank');
                                            }
                                        }}
                                    >
                                        Join Session
                                    </Button> */}

            

            {/* <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
  <ReserveButton postId={id} />
</Box> */}


            {/* {(paymentStatus === 'success' || bookingCreated) ? (

              <Box
                sx={{
                  mt: 4,
                  p: { xs: 2, sm: 3 },
                  textAlign: 'center',
                  borderRadius: 2,
                  backgroundColor: '#1a1a1a', // dark card background
                  boxShadow: 4,
                  maxWidth: 600,
                  margin: 'auto',
                  border: '1px solid #2e7d32', // optional green border for emphasis
                }}
              >
                <CheckCircleOutline
                  sx={{
                    fontSize: { xs: 40, sm: 50 },
                    color: '#4caf50', // Material green
                    mb: 1,
                  }}
                />

                <Typography
                  variant="h5"
                  sx={{
                    color: '#4caf50',
                    fontWeight: 700,
                    letterSpacing: 4,
                    fontSize: {
                      xs: '1.25rem',
                      sm: '1.5rem',
                      md: '1.75rem',
                    },
                    mb: 1,
                  }}
                >
                  Booking Confirmed!
                </Typography>

                {highlight.price > 0 && (
                  <Typography
                    variant="body1"
                    sx={{
                      color: '#cccccc', // soft light gray for dark background
                      letterSpacing: 2,
                      fontSize: {
                        xs: '0.95rem',
                        sm: '1rem',
                      },
                      lineHeight: 1.6,
                    }}
                  >
                    Thank you for your payment. We've successfully received your booking.
                  </Typography>
                )}


                <Typography
                  variant="body2"
                  sx={{
                    color: '#aaaaaa',
                    fontSize: {
                      xs: '0.85rem',
                      sm: '0.95rem',
                    },
                    letterSpacing: 2,
                  }}
                >
                  You can view your booking in{' '}
                  <MuiLink
                    component={Link}
                    to={`/my-bundle-booking-detail/${id}`}
                    underline="hover"
                    sx={{ color: '#ffffff', fontWeight: 'bold' }} // Customize as needed
                  >
                    My Bookings
                  </MuiLink>.
                </Typography>
              </Box>
            ) : paymentStatus === 'cancelled' ? (
              <>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    mt: 4,
                    px: 3,
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 2,
                      background: 'rgba(231, 76, 60, 0.1)',
                      borderRadius: '10px',
                      padding: '1rem 1.75rem',
                      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        transform: 'scale(1.03)',
                        boxShadow: '0 8px 18px rgba(0, 0, 0, 0.25)',
                      },
                    }}
                  >
                    <ErrorOutline
                      sx={{
                        fontSize: { xs: 32, sm: 40 },
                        color: '#e74c3c',
                      }}
                    />

                    <Typography
                      variant="h6"
                      sx={{
                        color: '#e74c3c',
                        fontWeight: 600,
                        letterSpacing: 2,
                        fontSize: {
                          xs: '1rem',
                          sm: '1.2rem',
                          md: '1.4rem',
                        },
                        textAlign: 'center',
                        lineHeight: 1.6,
                      }}
                    >
                      Payment was cancelled. Please try again.
                    </Typography>
                  </Box>
                </Box>

                <Button
                  component={Link}
                  to={`/bundle-payments/post/${id}`}
                  variant="contained"
                  fullWidth
                  sx={{
                    marginTop: "2rem",
                    backgroundColor: "#2980b9",
                    color: "#fff",
                    letterSpacing: 7,
                    textTransform: "none",
                    padding: "1rem",
                    fontWeight: "bold",
                  }}
                >
                  Retry Payment
                </Button>
              </>
            ) : (
              <>
                <Button
                  component={Link}
                  to={highlight.price > 0 ? `/bundle-payments/post/${id}` : '#'} // Conditionally navigate
                  variant="contained"
                  fullWidth
                  sx={{
                    marginTop: "2rem",
                    background: "linear-gradient(45deg, #1e90ff, #1c70ff)",
                    color: "#fff",
                    textTransform: "none",
                    letterSpacing: 7,
                    padding: "1rem 2rem", // Add horizontal padding for better appearance
                    fontWeight: "bold",
                    fontSize: {
                      xs: "1rem", // Smaller size for mobile
                      sm: "1.1rem", // Medium size for tablets and small screens
                      md: "1.2rem", // Larger size for desktops
                    },
                    borderRadius: "50px", // Rounded, pill-shaped button for a modern look
                    boxShadow: "0 12px 18px rgba(0, 0, 0, 0.1)", // Subtle shadow for depth
                    textAlign: "center",
                    transition: "background-color 0.3s ease, transform 0.3s ease, box-shadow 0.3s ease", // Smooth transitions for hover effects
                    "&:hover": {
                      background: "linear-gradient(45deg, #1e90ff, #1c70ff)", // Slightly darker gradient on hover
                      transform: "scale(1.05)", // Slight zoom effect on hover for interactivity
                      boxShadow: "0 18px 30px rgba(0, 0, 0, 0.2)", // Stronger shadow on hover for more depth
                    },
                    "@media (max-width: 600px)": {
                      padding: "0.8rem 1.5rem", // Adjust padding for small screens
                    },
                  }}
                  onClick={() => {
                    if (highlight.price <= 0) {
                      setOpenConfirmDialog(true);
                    }
                  }}
                >
                  Book Now
                </Button>
              </>
            )} */}



          


            <Dialog
              open={openConfirmDialog}
              onClose={() => setOpenConfirmDialog(false)}
              PaperProps={{
                sx: {
                  borderRadius: "16px",
                  padding: 2,
                  backgroundColor: "#000000", // Dark background
                  boxShadow: "0 20px 40px rgba(0, 0, 0, 0.6)",
                  maxWidth: 420,
                  mx: 'auto',
                },
              }}
              transitionDuration={300}
            >
              <DialogTitle
                sx={{
                  fontWeight: 'bold',
                  fontSize: '1.5rem',
                  textAlign: 'center',
                  color: '#1E90FF', // Accent color
                  pb: 1,
                }}
              >
                Confirm Booking
              </DialogTitle>

              <DialogContent sx={{ textAlign: 'center', px: 3 }}>
                <Typography sx={{ fontSize: '1rem', color: '#ccc' }}>
                  Are you sure you want to book this session?
                </Typography>
              </DialogContent>

              <DialogActions sx={{ justifyContent: 'center', gap: 2, mt: 2 }}>
                <Button
                  onClick={() => setOpenConfirmDialog(false)}
                  sx={{
                    borderRadius: '25px',
                    padding: '0.6rem 1.5rem',
                    backgroundColor: '#333',
                    color: '#ddd',
                    textTransform: 'none',
                    "&:hover": {
                      backgroundColor: '#444',
                    },
                  }}
                >
                  Cancel
                </Button>

                <Button
                  onClick={() => {
                    createUserPostBookings();
                    setOpenConfirmDialog(false);
                  }}
                  variant="contained"
                  sx={{
                    borderRadius: '25px',
                    padding: '0.6rem 1.8rem',
                    textTransform: 'none',
                    background: "linear-gradient(45deg, #1e90ff, #1c70ff)",
                    fontWeight: 'bold',
                    letterSpacing: 1,
                    color: '#fff',
                    "&:hover": {
                      transform: 'scale(1.05)',
                      boxShadow: '0 8px 20px rgba(30, 144, 255, 0.4)',
                    },
                  }}
                >
                  Confirm
                </Button>
              </DialogActions>
            </Dialog>
          </CardContent>
        </Card>

        {/* Session List */}
        <Typography variant="h5" gutterBottom fontWeight={500}>
          Sessions
        </Typography>

        <Grid container spacing={3}>
          {sessions.map((session) => (
            <Grid item xs={12} sm={6} md={4} key={session.id}>
              <Card
                onClick={() => handleSessionClick(session)}
                sx={{
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  borderRadius: 3,
                  background: 'rgba(255, 255, 255, 0.04)',
                  boxShadow: 3,
                  cursor: 'pointer',
                  transition: 'transform 0.3s',
                  '&:hover': {
                    transform: 'scale(1.03)',
                    boxShadow: 6,
                  },
                }}
              >
                {session.media_url && (
                  <CardMedia
                    component={session.media_type === 'video' ? 'video' : 'img'}
                    src={session.media_url}
                    controls
                    sx={{ height: 180, objectFit: 'cover' }}
                  />
                )}
                <CardContent sx={{ flexGrow: 1 }}>
                  <Typography variant="h6" gutterBottom fontWeight={600}>
                    {session.session_title || 'Untitled Session'}
                  </Typography>
                  <Grid container spacing={2} justifyContent="left" sx={{ mt: 1, mb: 5 }}>
                    {/* Date + Time + Duration */}
                    {session.selectedDate && session.startTime && session.duration && (
                      <Grid item>
                        <Typography
                          sx={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 1,
                            fontWeight: '600',
                            fontSize: '1rem',
                            color: '#ffffff',
                            background: 'linear-gradient(135deg, #2079c2ff 0%, #1f2c33ff 100%)',
                            px: 2,
                            py: 0.5,
                            borderRadius: '18px',
                            boxShadow: '0 2px 10px rgba(48, 71, 83, 0.4)',
                            whiteSpace: 'nowrap',
                            textShadow: '0 1px 2px rgba(0,0,0,0.4)',
                            letterSpacing: 0.4,
                            userSelect: 'none',
                            width: 'fit-content',
                            cursor: 'default',
                          }}
                        >
                          🗓
                          <span>
                            {formatTimeToAMPM(session.startTime)} • {formatDateWithSuffix(session.selectedDate)} • {formatDuration(session.duration)}
                          </span>
                        </Typography>
                      </Grid>
                    )}
                  </Grid>


                  {/* Session Description */}
                  <Grid item xs={12}>
                    <Typography
                      sx={{
                        background: 'rgba(255, 255, 255, 0.04)',
                        borderLeft: '4px solid #4caf50',
                        padding: 2,
                        borderRadius: '8px',
                        fontSize: '0.95rem',
                        lineHeight: 1.6,
                        color: '#dddddd',
                        boxShadow: 'inset 0 0 6px rgba(0,0,0,0.1)',
                        whiteSpace: 'normal',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                      }}
                    >
                      {session.description?.substring(0, 120) || 'No description available.'}
                      {session.description && session.description.length > 120 && '...'}
                    </Typography>
                  </Grid>
                  <JoinButton
  postId={session.id}
  hostUserId={userData?.expert_id}
  title={session.session_title}
/>
                   {/* <Button
                                                          variant="contained"
                                                          color="primary"
                                                          endIcon={<PlayCircleOutlineIcon />}
                                                          sx={{ mt: 2 }}
                                                          onClick={() => {
                                                              if (session?.meeting_link) {
                                                                  window.open(session.meeting_link, '_blank', 'noopener,noreferrer');
                                                              }
                                                          }}
                                                          disabled={!session?.meeting_link}
                                                      >
                                                          Join Session
                                                      </Button> */}

                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

      </Box>
      <Footer2 />
    </div>
  );
}

export default BundleDetail;
